import { INewbuildingForDeveloperCard } from '../repositories/newbuilding-search/entities/newbuilding_for_developer_card/NewbuildingForDeveloperCard';
import { INewbuildingCount as INewbuildingCountSchema } from '../repositories/newbuilding-search/entities/get_newbuildings_for_developer_card/NewbuildingCount';
import { INewBuilding, INewbuildingCount } from '../types/newBuldings';

/**
 * Преобразует URL выдачи новостроек в мобильный формат
 * Изменяет путь с /newobjects/list/ на /cat.php и добавляет необходимые параметры
 */
export function convertToMobileUrl(url: string): string {
  if (!url) {
    return url;
  }

  try {
    const urlObj = new URL(url, 'https://www.cian.ru');
    const params = new URLSearchParams(urlObj.search);

    params.set('offer_type', 'flat');
    params.set('newbuilding_results_type', 'newbuildings');
    params.set('object_type[0]', '2');
    params.set('with_newobject', '1');

    return `/cat.php?${params.toString()}`;
  } catch (error) {
    /** istanbul ignore next */
    return url;
  }
}

export function newbuildingMapper(newbuilding: INewbuildingForDeveloperCard): INewBuilding {
  return {
    additionalImages: newbuilding.additionalImages,
    address: newbuilding.address,
    coordinates: newbuilding.coordinates,
    finishLabel: newbuilding.finishLabel,
    flatStats: newbuilding.flatStats,
    id: newbuilding.id,
    image: newbuilding.image,
    isReliable: newbuilding.isReliable,
    labels: newbuilding.labels,
    promoList: newbuilding.promoList,
    publicUrl: newbuilding.publicUrl,
    searchList: newbuilding.searchList,
    subwayInfo: newbuilding.subwayInfo,
    title: newbuilding.title,
    phoneNumber: newbuilding.phoneNumber,
    isKpn: newbuilding.isKpn,
    reviewsStats: newbuilding.reviewsStats,
  };
}

export function newbuildingCountsMapper(counts: INewbuildingCountSchema[]): INewbuildingCount[] {
  return counts.map(item => ({
    displayName: item.displayName,
    count: item.count,
    newbuildingStatus: item.newbuildingStatus,
    listingUrl: item.listingUrl,
    mobileListingUrl: convertToMobileUrl(item.listingUrl),
  }));
}
